import * as Dialog from '@radix-ui/react-dialog';
import Sidebar from './Sidebar';

export const MobileNavigationDrawer = ({ open, onOpenChange }) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm" data-testid="mobile-navigation-backdrop" />
      <Dialog.Content className="mobile-navigation-drawer fixed inset-y-0 left-0 z-50 w-[min(320px,calc(100%-32px))] bg-neutral-950 outline-none"
        data-testid="mobile-navigation-drawer" aria-describedby={undefined}
        onCloseAutoFocus={event => { event.preventDefault(); document.querySelector('[data-testid="mobile-menu-button"]')?.focus(); }}>
        <Dialog.Title className="sr-only">Konattu navigation</Dialog.Title>
        <Sidebar onClose={() => onOpenChange(false)} />
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);